// extracted by mini-css-extract-plugin
export default {"formBox":"albumform_formBox__6f-d6","forms":"albumform_forms__+P+Tc"};